import axios from "../config/axios-mcp";

export const MCPServersRepository = {
    getAll: (projectId) => {
        return axios.get(`api/servers/${projectId}`);
    },
    reloadServer: (id) => {
        return axios.post(`api/servers/${id}/reload`);
    },
    delete: (id) => {
        return axios.delete(`api/servers/${id}`)
    },
    create: (data) => {
        return axios.post('api/servers', data)
    },
    edit: (id, data) => {
        return axios.patch(`api/servers/${id}`, data)
    },
    testConnection:(data)=>{
        return axios.post(`api/servers/test-connection`,data);
    },
    editServerToken:(id,data)=>{
        return axios.patch(`api/servers/${id}/token`,data);
    },
    getTools:(data)=>{
        return axios.post(`api/mcp/tools`,data);
    },
    callTool:(data)=>{
        return axios.post(`api/mcp/call`,data);
    },
    getPrompts:(data)=>{
        return axios.post(`api/mcp/prompts`,data);
    },
    getToolDetails:(data)=>{
        return axios.post(`api/mcp/get-tool-details`,data);
    },
    getAllServersWithDetails:(project_id)=>{
        return axios.get(`api/servers/${project_id}/servers-details`);
    },
    getServerWithDetails:(server_id)=>{
        return axios.get(`api/servers/${server_id}/server-details`);
    },
    deleteInactiveTool:(tool_id)=>{
        return axios.delete(`api/tools/${tool_id}`);
    }
}